import { Hint as e } from "../../components/hint.mjs";
import { getFontFamilyCode as t, getFontFamilyOptionsData as n } from "./utils.mjs";
import { useTranslation as r } from "../../i18n.mjs";
import { ToolbarSelect as i } from "../../components/content-controls/toolbar-select.mjs";
import { ToolbarSheetSelect as a } from "../../components/content-controls/toolbar-sheet-select.mjs";
import { isImageSelected as o } from "../image-extension/utils/is-image-selected.mjs";
import { useEditorState as s } from "@tiptap/react";
import { useMemo as c } from "react";
import { jsx as l } from "react/jsx-runtime";
//#region src/extensions/font-family-extension/use-font-family-extension-toolbar.tsx
var u = (u, d) => {
	let { t: f } = r(), { fontFamilyOptionsData: p, noFontFamilyElement: m, disabled: h } = d ?? {}, g = s({
		editor: u,
		selector: ({ editor: e }) => ({
			isEditable: e?.options.editable ?? !1,
			fontFamily: e?.getAttributes("textStyle").fontFamily,
			isImageSelected: o(e)
		})
	}), _ = !g?.isEditable || !!g?.isImageSelected || h, v = g?.fontFamily ? t(g.fontFamily) : void 0, y = c(() => p ?? n(), [p]), b = c(() => m ?? /* @__PURE__ */ l(e, {
		inline: !0,
		passive: !0,
		label: f("font_family.default_hint"),
		children: f("font_family.default")
	}), [m, f]);
	return c(() => {
		let e = (e) => {
			if (!u) return null;
			let t = y.find((t) => t.value === e)?.fontFamilyValue;
			if (!t) return null;
			u.chain().focus().setFontFamily(t).run();
		}, t = () => {
			u && u.chain().focus().unsetFontFamily().run();
		}, n = y.find((e) => e.value === v);
		return {
			toolbarRender: /* @__PURE__ */ l(i, {
				clearLabel: f("global.clear"),
				disabled: _,
				label: f("font_family.title"),
				labelledByContent: !0,
				onChange: e,
				onClear: v ? t : void 0,
				options: y,
				value: v,
				children: v ? n?.customLabel ?? n?.label : b
			}),
			sheetRender: /* @__PURE__ */ l(a, {
				disabled: _,
				label: f("font_family.title"),
				onChange: e,
				options: y,
				value: v
			})
		};
	}, [
		u,
		_,
		v,
		y,
		b,
		f
	]);
};
//#endregion
export { u as useFontFamilyExtensionToolbar };
